/* ============================================================
 Giu Giggi, theme interaction logic
 Cart (Shopify AJAX API), drawers, toast, accordions, showcase wiring.
 ============================================================ */
(function () {
 "use strict";

 var T = window.theme || {};
 var routes = T.routes || {};
 var THRESHOLD = (T.freeShippingThreshold || 150) * 100; // cents

 function el(id) { return document.getElementById(id); }
 function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
 function qsa(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }

 /* ---------- Money ---------- */
 function formatMoney(cents) {
 cents = typeof cents === "string" ? cents.replace(".", "") : cents;
 var fmt = T.moneyFormat || "€{{amount}}";
 function thousands(num, sep, dec) {
 num = (num / 100).toFixed(2);
 var parts = num.split(".");
 var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
 return { whole: whole, dec: parts[1] };
 }
 return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
 switch (key) {
 case "amount": { var p = thousands(cents, ".", "."); return p.dec === "00" ? p.whole : p.whole + "." + p.dec; }
 case "amount_no_decimals": return thousands(cents, ".").whole;
 case "amount_with_comma_separator": { var q = thousands(cents, "."); return q.whole + "," + q.dec; }
 case "amount_no_decimals_with_comma_separator": return thousands(cents, ".").whole;
 case "amount_with_space_separator": { var s = thousands(cents, " "); return s.whole + "," + s.dec; }
 default: return thousands(cents, ".").whole;
 }
 });
 }

 /* ---------- Toast ---------- */
 var toastTimer;
 function toast(msg) {
 var t = el("toast");
 if (!t) return;
 el("toast-msg").textContent = msg;
 t.classList.add("show");
 clearTimeout(toastTimer);
 toastTimer = setTimeout(function () { t.classList.remove("show"); }, 2400);
 }

 /* ---------- Drawers ---------- */
 function headerBottom() {
 var h = qs(".header");
 return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
 }
 function openCart() {
 var s = el("scrim");
 el("menu-drawer").classList.remove("open", "show-sub"); document.body.classList.remove("menu-open");
 s.style.top = "0px"; s.classList.remove("light");
 el("cart-drawer").classList.add("open"); s.classList.add("open");
 document.body.style.overflow = "hidden";
 }
 function closeCart() { el("cart-drawer").classList.remove("open"); maybeUnlock(); }
 function openMenu() {
 var t = headerBottom();
 var d = el("menu-drawer"); var s = el("scrim");
 d.style.top = t + "px";
 s.style.top = t + "px"; s.classList.add("light");
 el("cart-drawer").classList.remove("open");
 d.classList.add("open"); s.classList.add("open");
 document.body.classList.add("menu-open");
 document.body.style.overflow = "hidden";
 }
 function closeMenu() {
 el("menu-drawer").classList.remove("open");
 el("menu-drawer").classList.remove("show-sub");
 document.body.classList.remove("menu-open");
 maybeUnlock();
 }
 function maybeUnlock() {
 var open = el("cart-drawer").classList.contains("open") || el("menu-drawer").classList.contains("open");
 if (!open) {
 var s = el("scrim");
 s.classList.remove("open"); s.classList.remove("light");
 s.style.top = "0px";
 document.body.style.overflow = "";
 }
 }
 function toggleMenu() {
 if (el("menu-drawer").classList.contains("open")) closeMenu(); else openMenu();
 }

 /* ---------- Cart ---------- */
 function variantLine(item) {
 if (item.options_with_values && item.options_with_values.length) {
 return item.options_with_values
 .filter(function (o) { return o.value && o.value.toLowerCase() !== "default title"; })
 .map(function (o) { return o.value; })
 .join(" · ");
 }
 if (item.variant_title && item.variant_title.toLowerCase() !== "default title") {
 return item.variant_title.replace(/ \/ /g, " · ");
 }
 return "";
 }

 function bumpCount(count) {
 var badge = el("cart-count");
 if (!badge) return;
 badge.textContent = count;
 badge.classList.toggle("show", count > 0);
 }

 var _cartExtras;
 function getExtras() {
 if (_cartExtras !== undefined) return _cartExtras;
 var ex = el("cart-extras");
 try { _cartExtras = JSON.parse(ex.textContent); } catch (e) { _cartExtras = { sample: null, routine: [] }; }
 return _cartExtras;
 }
 function extrasHtml(cart) {
 var d = getExtras(), out = "";
 if (d.sample && d.sample.id) {
 var line = null, i;
 for (i = 0; i < cart.items.length; i++) { if (cart.items[i].variant_id === d.sample.id) { line = cart.items[i]; break; } }
 var on = !!line;
 out += '<div class="cart-extra">'
 + '<div class="cart-extra__head">Kies je gratis staal <span>(' + (on ? 1 : 0) + '/1)</span></div>'
 + '<div class="cart-extra__row' + (on ? " is-on" : "") + '">'
 + (d.sample.image ? '<img src="' + d.sample.image + '" alt="">' : '<span class="cart-extra__ph"></span>')
 + '<div class="cart-extra__info"><span class="t">' + d.sample.title + '</span><span class="p">Gratis</span></div>'
 + '<button class="cart-extra__btn" data-sample="' + d.sample.id + '" data-in="' + (on ? "1" : "0") + '"' + (on ? ' data-key="' + line.key + '"' : "") + '>' + (on ? "Verwijder" : "Toevoegen") + '</button>'
 + '</div></div>';
 }
 var routine = (d.routine || []).filter(function (p) {
 for (var j = 0; j < cart.items.length; j++) { if (cart.items[j].product_id === p.productId) return false; }
 return true;
 }).slice(0, 3);
 if (routine.length) {
 out += '<div class="cart-extra"><div class="cart-extra__head">Maak je routine compleet</div>';
 routine.forEach(function (p) {
 out += '<div class="cart-extra__row">'
 + (p.image ? '<img src="' + p.image + '" alt="">' : '<span class="cart-extra__ph"></span>')
 + '<div class="cart-extra__info"><span class="t">' + p.title + '</span><span class="p">' + formatMoney(p.price) + '</span></div>'
 + (p.multi
 ? '<button class="cart-extra__btn" data-quickshop data-handle="' + p.handle + '">Kies</button>'
 : '<button class="cart-extra__btn" data-add-routine="' + p.id + '">Toevoegen</button>')
 + '</div>';
 });
 out += "</div>";
 }
 return out;
 }

 function renderCart(cart) {
 bumpCount(cart.item_count);
 var body = el("cart-body");
 var foot = el("cart-foot");
 if (!body) return;

 if (!cart.items.length) {
 body.innerHTML =
 '<div class="cart-empty"><span class="serif-italic">Je mandje is leeg</span>' +
 "Nog even rondkijken in de collectie." +
 '<div style="margin-top:22px"><a class="btn" href="/collections/bestsellers" data-close-cart>Shop de collectie</a></div></div>';
 if (foot) foot.style.display = "none";
 return;
 }

 body.innerHTML = cart.items.map(function (item) {
 var media = item.image
 ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, "_140x$1$2") + '" alt="" loading="lazy">'
 : '<div class="media-slot"></div>';
 var variant = variantLine(item);
 return (
 '<div class="cart-item">' +
 '<a class="ci-media" href="' + item.url + '">' + media + "</a>" +
 "<div>" +
 '<a class="ci-name" href="' + item.url + '">' + item.product_title + "</a>" +
 (variant ? '<div class="ci-var">' + variant + "</div>" : "") +
 '<div class="ci-qty">' +
 '<button data-dec="' + item.key + '" aria-label="Minder">−</button>' +
 "<span>" + item.quantity + "</span>" +
 '<button data-inc="' + item.key + '" aria-label="Meer">+</button>' +
 "</div>" +
 "</div>" +
 "<div>" +
 '<div class="ci-price">' + formatMoney(item.final_line_price) + "</div>" +
 '<button class="ci-remove" data-rm="' + item.key + '">Verwijder</button>' +
 "</div>" +
 "</div>"
 );
 }).join("") + extrasHtml(cart);

 if (foot) {
 foot.style.display = "block";
 el("cart-subtotal").textContent = formatMoney(cart.total_price);
 var note = el("cart-note");
 if (note) {
 var rem = THRESHOLD - cart.total_price;
 note.textContent = rem > 0
 ? "Nog " + formatMoney(rem) + " tot gratis verzending."
 : "Je bestelling wordt gratis verzonden.";
 }
 }

 qsa("[data-dec]", body).forEach(function (b) { b.onclick = function () { changeLine(b.dataset.dec, -1); }; });
 qsa("[data-inc]", body).forEach(function (b) { b.onclick = function () { changeLine(b.dataset.inc, 1); }; });
 qsa("[data-rm]", body).forEach(function (b) { b.onclick = function () { removeLine(b.dataset.rm); }; });
 qsa("[data-close-cart]", body).forEach(function (b) { b.addEventListener("click", function () { closeCart(); }); });
 qsa("[data-sample]", body).forEach(function (b) { b.onclick = function () { if (b.dataset.in === "1") { updateLine(b.dataset.key, 0); } else { addToCart(b.dataset.sample, 1); } }; });
 qsa("[data-add-routine]", body).forEach(function (b) { b.onclick = function () { addToCart(b.dataset.addRoutine, 1); }; });
 }

 function fetchCart() {
 return fetch(routes.cart || "/cart.js", { headers: { Accept: "application/json" } })
 .then(function (r) { return r.json(); })
 .then(function (cart) { renderCart(cart); return cart; });
 }

 var cartLineMap = {}; // key -> quantity, kept in sync via fetchCart
 function changeLine(key, delta) {
 // read current qty from DOM span
 var btn = qs('[data-inc="' + key + '"]') || qs('[data-dec="' + key + '"]');
 var span = btn ? btn.parentElement.querySelector("span") : null;
 var current = span ? parseInt(span.textContent, 10) : 1;
 var next = Math.max(0, current + delta);
 updateLine(key, next);
 }
 function removeLine(key) { updateLine(key, 0); }

 function updateLine(key, quantity) {
 fetch(routes.cart_change || "/cart/change.js", {
 method: "POST",
 headers: { "Content-Type": "application/json", Accept: "application/json" },
 body: JSON.stringify({ id: key, quantity: quantity })
 })
 .then(function (r) { return r.json(); })
 .then(function (cart) { renderCart(cart); })
 .catch(function () { toast("Er ging iets mis"); });
 }

 function addToCart(variantId, quantity, onDone) {
 quantity = quantity || 1;
 return fetch(routes.cart_add || "/cart/add.js", {
 method: "POST",
 headers: { "Content-Type": "application/json", Accept: "application/json" },
 body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
 })
 .then(function (r) {
 if (!r.ok) return r.json().then(function (e) { throw e; });
 return r.json();
 })
 .then(function (added) {
 return fetchCart().then(function () {
 var name = (added.items && added.items[0] && added.items[0].product_title) || (added.product_title) || "Product";
 toast(name + " toegevoegd");
 openCart();
 if (onDone) onDone(true);
 });
 })
 .catch(function (err) {
 toast((err && err.description) || "Niet beschikbaar");
 if (onDone) onDone(false);
 });
 }

 /* ---------- Accordions ---------- */
 function bindAccordions() {
 qsa(".acc-head").forEach(function (h) {
 h.onclick = function () {
 var item = h.parentElement;
 var body = item.querySelector(".acc-body");
 var open = item.classList.toggle("open");
 body.style.maxHeight = open ? body.scrollHeight + "px" : "0";
 };
 });
 // open any default-open accordions
 qsa(".acc-item.open .acc-body").forEach(function (b) { b.style.maxHeight = b.scrollHeight + "px"; });
 }

 /* ---------- Wiring ---------- */
 function wire() {
 var btnCart = el("btn-cart");
 if (btnCart) btnCart.onclick = function (e) { e.preventDefault(); openCart(); };
 var btnMenu = el("btn-menu");
 if (btnMenu) btnMenu.onclick = function () { toggleMenu(); };
 var cartClose = el("cart-close");
 if (cartClose) cartClose.onclick = function () { closeCart(); };
 var scrim = el("scrim");
 if (scrim) scrim.onclick = function () { closeCart(); closeMenu(); };
 var cartCont = el("cart-continue");
 if (cartCont) cartCont.onclick = function (e) { e.preventDefault(); closeCart(); };

 var btnSearch = el("btn-search");
 if (btnSearch) btnSearch.onclick = function () {
 openMenu();
 setTimeout(function () { var inp = qs("#menu-drawer input[type=search]"); if (inp) inp.focus(); }, 380);
 };

 var openSub = el("menu-open-sub");
 if (openSub) openSub.onclick = function (e) { e.preventDefault(); el("menu-drawer").classList.add("show-sub"); };
 var back = el("menu-back");
 if (back) back.onclick = function () { el("menu-drawer").classList.remove("show-sub"); };

 qsa("[data-news-open]").forEach(function (b) {
 b.onclick = function () {
 closeMenu();
 var news = qs(".news");
 if (news) setTimeout(function () {
 var y = news.getBoundingClientRect().top + window.scrollY - 80;
 window.scrollTo({ top: y, behavior: "smooth" });
 }, 320);
 };
 });

 // Quick-add from product cards
 document.addEventListener("click", function (e) {
 var add = e.target.closest("[data-add]");
 if (add) {
 e.preventDefault();
 var vid = add.dataset.add;
 if (!vid) { toast("Kies eerst een variant"); return; }
 var orig = add.textContent;
 add.disabled = true;
 addToCart(vid, 1, function (ok) {
 add.disabled = false;
 if (ok) {
 add.textContent = "Toegevoegd ✓";
 add.classList.add("added");
 setTimeout(function () { add.textContent = orig; add.classList.remove("added"); }, 1400);
 }
 });
 }
 });

 document.addEventListener("keydown", function (e) {
 if (e.key === "Escape") { closeCart(); closeMenu(); }
 });
 }

 // Expose for product section
 window.GiuGiggi = { addToCart: addToCart, fetchCart: fetchCart, toast: toast, formatMoney: formatMoney, openCart: openCart };

 document.addEventListener("DOMContentLoaded", function () {
 wire();
 bindAccordions();
 fetchCart();
 });
})();
